import { render, staticRenderFns } from "./diamondIcon.vue?vue&type=template&id=39a8b335&"
import script from "./diamondIcon.vue?vue&type=script&lang=js&"
export * from "./diamondIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports